<template>
    <el-dialog title="申请入库" :visible.sync="dialogVisible" width="60%">
        <div class="box-card" v-if="Object.keys(infoData).length">
            <el-row class="custom-container">
                <el-col :span="4">
                    <el-image
                        style="width: 100%; height: 100%;"
                        :src="infoData.imagesList[0]"
                        :preview-src-list="infoData.imagesList"
                    ></el-image>
                </el-col>
                <el-col :span="18" :offset="2">
                    <div class="inform flex">
                        <div class="title">库存编号：</div>
                        <div>{{ infoData.inventoryNumber }}</div>
                    </div>
                    <div class="inform flex">
                        <div class="title">公司：</div>
                        <div>{{ infoData.branchCompanyName }}</div>
                    </div>
                    <div class="inform flex">
                        <div class="title">全称：</div>
                        <div>{{ infoData.productFullName }}</div>
                    </div>
                    <div class="inform flex">
                        <div class="title">简称：</div>
                        <div>{{ infoData.productSimpleName }}</div>
                    </div>
                    <div class="inform flex">
                        <div class="title">描述：</div>
                        <div>{{ infoData.productDescription }}</div>
                    </div>
                       <div class="inform flex">
                        <div class="title">规格尺寸：</div>
                        <div>{{ infoData.inventorySku }}</div>
                    </div>
                    <el-row type="flex" justify="space-between">
                        <div class="inform flex">
                            <div class="title">即时库存数量：</div>
                            <div>{{infoData.actualCount}}</div>
                        </div>
                        <el-button type="primary" @click="BarCode">条线码打印</el-button>
                    </el-row>
                </el-col>
            </el-row>
            <div class="custom-container" v-if="Object.keys(infoPurchase).length">
                <div style="width:100%;">
                    <el-divider></el-divider>
                    <el-row>
                        <el-col :span="8">
                            <div class="inform">采购单据号：{{ infoPurchase.purchaseNumber }}</div>
                        </el-col>
                        <el-col :span="8">
                            <div class="inform">运单号：{{ infoPurchase.internalConveyNumber }}</div>
                        </el-col>
                    </el-row>
                    <div class="inform">海逊仓库核对详情：{{ infoPurchase.purchaseModel }}</div>
                    <el-row>
                        <el-col :span="8">
                            <div class="inform">入库尺寸：{{ infoPurchase.purchaseSize }}</div>
                        </el-col>
                        <el-col :span="8">
                            <div class="inform">入库重量：{{ infoPurchase.purchaseWeight }}</div>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="8">
                            <div class="inform">材积重：{{ infoPurchase.purchaseSize }}</div>
                        </el-col>
                        <el-col :span="8">
                            <div class="inform">计费重：{{ infoPurchase.purchaseWeight }}</div>
                        </el-col>
                    </el-row>
                </div>
            </div>
            <div class="custom-container">
                <div style="width:100%;">
                    <el-divider></el-divider>
                    <el-row>
                        <el-col :span="3">
                            <!-- <div class="inform" v-if="JSON.stringify(infoPurchase)!=='{}'">申请数量：{{ infoPurchase.actualCount }}</div> -->
                            <div class="inform">申请数量：{{infoData.actualCount}}</div>
                        </el-col>
                        <el-col :span="7">
                            <span class="inform">仓库名称：</span>
                            <el-select v-model="formData.warehouse" value-key="id" @change="getShelvesList">
                                <el-option
                                    v-for="item in listWarehouse"
                                    :key="item.id"
                                    :label="item.warehouseName"
                                    :value="item"
                                ></el-option>
                            </el-select>
                        </el-col>
                        <el-col :span="6">
                            <span class="inform">货架：</span>
                            <el-select filterable v-model="formData.shelves" value-key="id">
                                <el-option
                                    v-for="item in listShelves"
                                    :key="item.id"
                                    :label="item.shelfNumber"
                                    :value="item"
                                ></el-option>
                            </el-select>
                        </el-col>
                        <el-col :span="6">
                            <span class="inform">重量：</span>
                            <el-input v-model="formData.inventoryWeight" style="width:200px;"></el-input>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </div>

        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="infoCheckDone" :loading="isDoneBtnLoding">确认入库</el-button>
        </span>
    </el-dialog>
</template>
<script>
import { ajaxPost, Baseurl } from "@/api/api/api";

export default {
    name: "Application_for_export",
    data() {
        return {
            dialogVisible: false,
            infoData: {},
            isDoneBtnLoding: false,
            infoPurchase: {},
            listWarehouse: [],
            listShelves: [],
            formData: {
                warehouse: "",
                shelves: {},
                inventoryWeight:"",
                inventoryBatchNo:""
            },
        };
    },
    methods: {
        init(row) {
            
                 const APIonE = Baseurl + "inventoryController/getDefaultShelfByInventoryNumber";
                  const param = {
                inventoryNumber:row.inventoryNumber
            }
            ajaxPost(APIonE,param).then(res=>{
                if(res.data.code ==200){
                    this.formData.shelves = res.data.data;
                }
            })
            this.dialogVisible = true;
            this.infoData = row;
            // console.log(this.infoData.id)
            this.getPurchaseInfo();
            this.getWarehouseList();
            this.formData.inventoryWeight = row.billingWeight;
            this.formData.inventoryBatchNo = row.inventoryBatchNo;
        },
        close() {
            this.dialogVisible = false;
            this.isDoneBtnLoding = false;
            this.infoData = {};
        },
        getPurchaseInfo() {
            const API = Baseurl + "inventoryController/getPurchaseByInventoryBatchNo";
            const paramsData = {
                inventoryBatchNo: this.infoData.inventoryBatchNo,
            };
            ajaxPost(API, paramsData).then(res => {
                const { code, data } = res.data;

                if (code === 200) {
                    this.infoPurchase = data || {};
                }
            });
        },
        infoCheckDone() {
            const { warehouse, shelves ,inventoryWeight} = this.formData;
            // return;
           let shelvesN,shelfTypeN;
           if(shelves != null){
                if(typeof(shelves)=="object"){
                    shelvesN  = shelves.shelfNumber;
                    shelfTypeN = shelves.shelfType;
                }else{
                    shelvesN = shelves;
                    shelfTypeN = this.infoData.shelfType
                }
           }else{
                this.$message.warning("请先选择货架");
                return;
           }
           
            if (shelvesN==null) {
                this.$message.warning("请先选择货架");
                return;
            }else if(inventoryWeight == ""){
                this.$message.warning("请填写重量");
                return;
            }
            this.isDoneBtnLoding = true;
            const paramsData = {
                inventoryBatchNo:this.formData.inventoryBatchNo,
                warehouseName: warehouse.warehouseName,
                shelfType: shelfTypeN,
                shelfNumber: shelvesN,
                inventoryWeight:inventoryWeight,
                inventoryId: this.infoData.inventoryId,
                id: this.infoData.id,
                operateType: this.infoData.operateType
            };
            this.$emit("confirm", paramsData);
        },
        getWarehouseList() {
            if (this.listWarehouse.length) return;
            const API = Baseurl + "inventoryController/getWarehouseList";
            ajaxPost(API).then(res => {
                const { code, data } = res.data;
                if (code === 200) {
                    this.listWarehouse = data;
                    this.formData.warehouse = data[0];
                    if (Object.keys(this.formData.warehouse).length) this.getShelvesList();
                }
            });
        },
        getShelvesList() {
            if (!Object.keys(this.formData.warehouse).length) return;
            const API = Baseurl + "inventoryController/getShelfsByWarehouseId";
       
            const paramsData = {
                warehouseId: this.formData.warehouse.id,
            };
           
            ajaxPost(API, paramsData).then(res => {
                const { code, data } = res.data;
                if (code === 200) {
                    this.listShelves = data;
                }
            });
        },
        BarCode(){
            const API = Baseurl + "inventoryPdfPrintController/pdfPrint";
            const paramsData = { id:this.infoData.id};
            ajaxPost(API, paramsData).then(res => {
                window.open(res.data.data, '_blank');
            });
        },
    },
};
</script>
<style lang="scss" scoped>
.custom-container {
    padding: 0 20px;
    display: flex;
    align-items: center;
}
.inform {
    line-height: 30px;
    &.flex {
        display: flex;
        .title {
            flex-shrink: 0;
            font-weight: bold;
        }
    }
}
.channel-flex {
    display: flex;
    margin-right: 20px;
}
</style>
